export const launch = [
    {
      "quantity":1,
      "id":2,
    "name":"Peri Peri 10 Strips with Dynamite",
    "detail":"10 Spicy Peri Peri chicken strips & our Dynamite Spicy Mayo Sauce Bottle",
    "price":639.05,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00002153.jpg?ver=20.85"
  
    },
    {
      "quantity":1,
      "id":3,
    "name":"Peri Peri 10 Strips with Nashville",
    "detail":"10 Spicy Peri Peri chicken strips & our Nashville Hot Sauce Bottle",
    "price":639.05,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00002154.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":4,
    "name":"Peri Peri 10 Leg pc & 4 Dips",
    "detail":"Leg before any wicket! Save 27% on 10 Spicy Peri Peri Leg Pieces & 4 Dips",
    "price":924.76,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00002155.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":5,
    "name":"Peri Peri 5 Leg Pc Meal",
    "detail":"5 Spicy Peri Peri Leg Pieces, 2 Dips, 1 Med Fries & a Pepsi PET",
    "price":628.57,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00002156.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":6,
    "name":"Mega Feast",
    "detail":"Feast up with 2 Hot & Crispy, 2 Smoky Red Chicken, 1 Bun, 1 Rice & gravy, Med Fries & Pepsi PET",
    "price":399.04,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00002123.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":7,
    "name":"Peri Peri 5 Leg Pc & 2 Dips",
    "detail":"5 Spicy Peri Peri Leg Pieces, paired with 2 delicous dips",
    "price":515.24,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00002157.jpg?ver=20.85"
    },
    {
      "id":8,
    "name":"6pc Hot & Crispy with Dynamite Sauce",
    "detail":"6pc Hot & Crispy Chicken paired with our new Dynamite Spicy Mayo Sauce Bottle",
    "price":779.05,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00002093.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":9,
    "name":"Peri Peri 6pc Chicken Strips",
    "detail":"6 Spicy Peri Peri chicken strips",
    "price":279.05,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00002158.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":10,
    "name":"6pc Hot & Crispy with Nashville Sauce",
    "detail":"6pc Hot & Crispy Chicken paired with our new Nashville Hot Pepper Sauce Bottle",
    "price":779.05,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00002094.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":11,
    "name":"Solo Feast",
    "detail":"Treat yourself with 1 Hot & Crispy, 2 Strips, 2 Wings, 1 Buttered Bun, 1 Dip & Pepsi PET",
    "price":399.05,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00002164.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":12,
    "name":"Strips & Rice Combo",
    "detail":"4 strips, 1 Dips, flavorful Rice & Gravy at a deal price",
    "price":359.06,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00002165.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":13,
    "name":"Friendship Bucket with Dynamite Sauce",
    "detail":"3pc Hot & Crispy, 3 Wings, 3 Strips, Large Popcorn & our new Dynamite Mayo Bottle",
    "price":879.05,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00002172.jpg?ver=20.85"
    },
    {
      "quantity":1,
      "id":14,
    "name":"Friendship Bucket with Nashville Sauce",
    "detail":"3pc Hot & Crispy, 3 Wings, 3 Strips, Large Popcorn & our new Nashville Bottle",
    "price":879.05,
    "image":"https://orderserv-kfc-assets.yum.com/15895bb59f7b4bb588ee933f8cd5344a/images/items/lg/D-PR00002173.jpg?ver=20.85"
    }
    ];